/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropkinddaily2Inputs */

const en_dropkinddaily2 = /** @type {(inputs: Dropkinddaily2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily drop`)
};

const de_dropkinddaily2 = /** @type {(inputs: Dropkinddaily2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täglicher Drop`)
};

/**
* | output |
* | --- |
* | "Daily drop" |
*
* @param {Dropkinddaily2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropkinddaily2 = /** @type {((inputs?: Dropkinddaily2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropkinddaily2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropkinddaily2(inputs)
	return de_dropkinddaily2(inputs)
});
export { dropkinddaily2 as "dropKindDaily" }